module.exports = __webpack_public_path__ + "static/illness-43a05fd9cdfe6bae3bce9c49c4f1321d.jpg";